module.exports = __webpack_public_path__ + "media/images/emblems/Liddes_blazono-2fa302d15c5f991fbaaab33f9843e820.png";